<template>
    <div class="card h-100 rounded-0 border-0" :class="animation">
        <div class="card-body text-center h-100">
            <div class="row">
                <BackButton @click.native="handleBackToStep()" />
            </div>
            <div class="row">
                <div class="form-wrap-step">
                    <div class="form-header">
                        <h5 class="title__normal">ご希望のゴミの種類を選択してください</h5>
                    </div>
                </div>
            </div>
            <div class="form-wrap-step">
                <div class="row mb-1">
                    <div class="col-md-12 below-adv-btn">
                        <!-- 粗大(1) -->
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg rounded-1" @click="handleClick(TRASH_TYPE_OVERSIZED)">
                            <span data-type="粗大" class="text">粗大ゴミ</span>
                        </button>
                        <!-- 家電(2) -->
                        <button class="btn btn-yellow-dark px-4 d-inline-block btn-lg rounded-1" @click="handleClick(TRASH_TYPE_APPLIANCE)">
                            <span data-type="家電" class="text">家電ゴミ</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackButton from './BackButton.vue';

    export default {
    name: 'GarbageType',
    props: {
        animation: {
            default: ''
        }
    },
    data() {
        return {
            TRASH_TYPE_OVERSIZED: 3,
            TRASH_TYPE_APPLIANCE: 4,
        };
    },
    methods: {
        handleClick(trashType) {
            if (trashType == this.TRASH_TYPE_OVERSIZED) {
                let currentStep = 2;
                let followStep = 1;

                this.$emit("handleChangeStep", currentStep, followStep);

                this.$emit("setTrashType", {
                    label: 'general',
                    data: {
                        trashType: this.TRASH_TYPE_OVERSIZED
                    }
                });
            }
            if (trashType == this.TRASH_TYPE_APPLIANCE) {
                let currentStep = 1;
                let followStep = 2;

                this.$emit("handleChangeStep", currentStep, followStep);

                this.$emit("setTrashType", {
                    label: 'general',
                    data: {
                        trashType: this.TRASH_TYPE_APPLIANCE
                    }
                });
            }
        },
        handleBackToStep() {
            let currentStep = 1;
            let followStep = 0;
            this.$emit("handleChangeStep", currentStep, followStep);
        }
    },
    components: { 
        BackButton 
    }
}   
</script>